import { useRef, useState } from "react";
import { AlertDialog, AlertDialogHeader, AlertDialogOverlay, AlertDialogContent, AlertDialogBody, AlertDialogFooter, Button } from "@chakra-ui/react";
import { DangerIcon } from "lib/icons/danger";
import { useAppDispatch } from "lib/redux";
import { updateTeam } from "domains/team";
import { refreshMe } from "domains/account";
import { baseRESTUrl } from "lib/utils";
import { getSubscription } from "domains/subscription";

export const DeleteTeamAlert = ({ isOpen, onClose }) => {
  const cancelRef = useRef();
  const dispatch = useAppDispatch();
  const [pending, setPending] = useState<boolean>(false);
  
  const scheduleDelete = async () => {
    setPending(true)
    try {
      await dispatch(updateTeam({delete_scheduled: true})).unwrap();
      await dispatch(refreshMe(baseRESTUrl())).unwrap();
      await dispatch(getSubscription()).unwrap();
      onClose();
    }
    catch(e) {
      setPending(false);
      console.error(e);
    }
  }

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent className="dialog__content">
        <AlertDialogHeader className="dialog-delete__header">
          <DangerIcon width="22px" height="22px"/>
          Are you sure you wish to DELETE this team?
        </AlertDialogHeader>
        <AlertDialogBody className="dialog-delete__content">
          This team will be deleted in 25 days, after which, all administrators and members associated with this team will lose access to all packs. In accordance with privacy regulations, we cannot reinstate a deleted team. Once it's gone, it's gone.
        </AlertDialogBody>
        <AlertDialogFooter className="dialog-delete__footer">
          <Button variant="cancel" ref={cancelRef} onClick={onClose}>Cancel</Button>
          <Button
            variant="destructive"
            isLoading={pending}
            title="Yes, delete this team"
            onClick={() => scheduleDelete()}
          >
            Yes, delete this team
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
};
